function Sent(){
    return (
    <div className="flex h-screen justify-center items-center w-full">
        <div className="text-7xl text-center font-serif w-full font-bold bg-white text-gray-600">Message has been sent!</div>
    </div>
    )
}

export default Sent;